import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'callType'
})
export class CallTypePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
